angular
  .module('admin')

  .directive('selectManager', function() {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        manager: '=',
        type: '@'
      },
      template:
        '<select ng-model="manager" ng-options="m as (m.first_name + \' \'+ m.last_name) for m in managers track by m._id">' +
        '<option value="">-</option>' +
        '</select>',
      controller: [
        '$scope',
        '$controller',
        'UserCrud',
        'AccountManagerCache',
        'AdminManagerCache',
        'PMCache',
        function(
          $scope,
          $controller,
          UserCrud,
          AccountManagerCache,
          AdminManagerCache,
          PMCache
        ) {
          $controller('ListCtrl', {
            $scope: $scope,
            crud: new UserCrud($scope),
            packageName: 'manager',
            dataName: 'managers',
            filters: {
              limit: 100000,
              page: 1
            }
          });

          const { type } = $scope;
          let cache;

          if ($scope.type === 'am') cache = AccountManagerCache;
          else if ($scope.type === 'admin') cache = AdminManagerCache;
          else if ($scope.type === 'pm') cache = PMCache;

          const managers = cache && cache.get();
          if (managers) return ($scope.managers = managers);

          $scope
            .loadList({ type })
            .then(() => cache && cache.set($scope.managers));
        }
      ]
    };
  });
